import { useCallback, useRef } from 'react';

export const useDebounce = (delay = 3000) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isFirstTime = useRef(true);

  const debouncedFn = useCallback(
    (func: () => void) => {
      if (isFirstTime.current) {
        isFirstTime.current = false;
        func();
        timeoutRef.current = null;
      } else {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(func, delay);
      }
    },
    [delay]
  );
  return { debouncedFn };
};
